/*
 * Compra de la suscripción PRIME (mensual/anual) desde las landings de ciudad.
 * Replica el patrón ya usado en sections/main-product.liquid (bloque prime_price):
 * el selling_plan_id no es fiable desde los objetos Liquid de all_products, así que
 * se resuelve vía fetch a /products/{handle}.js y se añade al carrito con
 * fetch('/cart/add.js', ...) + selling_plan, redirigiendo a checkout.
 *
 * Markup esperado (ver sections/landing-pricing.liquid):
 *   <div data-landing-prime data-mensual-handle="..." data-anual-handle="...">
 *     <div data-plan-type="mensual" class="landing-prime-plan active">...</div>
 *     <div data-plan-type="anual" class="landing-prime-plan">...</div>
 *     <button data-landing-prime-btn>...</button>
 *   </div>
 */
(function () {
  function loadPlan(handle, onData) {
    if (!handle) { onData(null); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (p) {
        var v = p.variants && p.variants[0];
        var alloc = v && v.selling_plan_allocations && v.selling_plan_allocations[0];
        onData(alloc ? { variantId: v.id, planId: alloc.selling_plan_id } : null);
      })
      .catch(function (err) {
        console.error('landing-prime: error cargando', handle, err);
        onData(null);
      });
  }

  function initContainer(container) {
    var plans = {};
    var mensualHandle = container.dataset.mensualHandle;
    var anualHandle = container.dataset.anualHandle;
    var planEls = container.querySelectorAll('[data-plan-type]');
    var btn = container.querySelector('[data-landing-prime-btn]');
    var selected = container.querySelector('[data-plan-type].active');
    var selectedType = selected ? selected.dataset.planType : (planEls[0] && planEls[0].dataset.planType);

    var pending = 0;
    if (mensualHandle) pending += 1;
    if (anualHandle) pending += 1;

    function markReady() {
      pending -= 1;
      if (pending <= 0 && btn) btn.removeAttribute('data-loading');
    }

    if (mensualHandle) {
      loadPlan(mensualHandle, function (data) { plans.mensual = data; markReady(); });
    }
    if (anualHandle) {
      loadPlan(anualHandle, function (data) { plans.anual = data; markReady(); });
    }

    planEls.forEach(function (el) {
      el.addEventListener('click', function () {
        planEls.forEach(function (p) { p.classList.remove('active'); });
        el.classList.add('active');
        selectedType = el.dataset.planType;
      });
    });

    if (btn) {
      var originalLabel = btn.textContent;
      btn.addEventListener('click', function () {
        var data = plans[selectedType];
        if (!data) {
          alert('No se pudo cargar el plan PRIME seleccionado. Inténtalo de nuevo en unos segundos.');
          return;
        }
        btn.disabled = true;
        btn.textContent = 'Añadiendo...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: data.variantId, quantity: 1, selling_plan: data.planId }]
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('landing-prime: error al añadir al carrito', err);
            btn.disabled = false;
            btn.textContent = originalLabel;
            alert('Error al añadir PRIME al carrito. Inténtalo de nuevo.');
          });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-landing-prime]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
